<script lang="ts">
  import { onMount } from "svelte";
import Button from "../../../components/Button.svelte";
import ClfDropdown from "../../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
import FormField from "../../../components/Form/FormField.svelte";
import SearchHeader from "../../../components/SearchHeader.svelte";
import { Table } from "../../../components/Table";
import MainLayout from "../../../layout/MainLayout.svelte";
import { reportmagazineDtoFields } from "../../../utils/TableFields/report-magazine-dto.fields";

  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onExport,
    onPageChange,
    search,
    clearSearch,
    tableCustomFields,
  } from "./reportmagazine.store";

  $: tableFields = [...reportmagazineDtoFields, ...$tableCustomFields];

  onMount(initList);
</script>

<MainLayout>
  <!-- svelte-ignore missing-declaration -->
  <SearchHeader
    entitySingular="record"
    entityPlural="records"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
  <div slot="search" class="level">
     
    <div class="level-item">
      <div style="width: 8rem;"> 
        <FormField>
          <ClfDropdown
          schema="MAGAZINEXX"
          required={false}
          clearVisible={false}
          bind:value={$filter.criteria.clfMagazineId}
          on:select={search}
        />   
        </FormField>        
      </div>      
    </div>
    
    <div class="level-item">
      <p class="control">
        <Button on:click={clearSearch}>Azzera</Button>
      </p>
    </div> 
  </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={tableFields}
    records={$records}
    pagination={$pagination}
    exportEnabled={true}
    on:export={(_) => onExport()}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
